import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const links = [{
    label: 'About us',
    href: '/about',
    isInternal: true
  }, {
    label: 'Careers',
    href: 'https://jobs.gem.com/fifthdoor-com',
    isInternal: false
  }, {
    label: 'Discord',
    href: 'https://discord.gg/HCC76Zt82Y',
    isInternal: false
  }];
  return <footer className="w-full relative overflow-hidden" style={{
    backgroundColor: '#000000',
    paddingTop: '2rem'
  }} data-id="element-54" data-mp="3uesa9h2573hk">
      {/* Noise texture overlay */}
      <div className="absolute inset-0 pointer-events-none" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/bonQpX7FQKEhKvnQfRNJtT/noise-background.png)',
      backgroundRepeat: 'repeat',
      backgroundSize: '200px 200px',
      opacity: 0.24
    }} data-id="element-55" data-mp="3levi35gjnmhr" />

      <div className="relative z-10 w-full" data-id="element-56" data-mp="2ezuubn1oaam9">
        <div className="max-w-7xl mx-auto px-4" data-id="element-57" data-mp="3l9adfilcf44f">
          {/* Navigation Links */}
          <div className="flex justify-between items-center mb-6 md:mb-8 px-4 md:px-12" data-id="element-58" data-mp="3lbdb8osqm1jp">
            {links.map(link => link.isInternal ? <Link key={link.label} to={link.href} onClick={() => window.scrollTo(0, 0)} className="text-white font-medium hover:opacity-80 transition-opacity" style={{
            fontFamily: "'Instrument Sans', sans-serif",
            fontSize: '16px'
          }} data-id="element-59" data-mp="3v9b0nfmc24dw">
                  {link.label}
                </Link> : <a key={link.label} href={link.href} className="text-white font-medium hover:opacity-80 transition-opacity" style={{
            fontFamily: "'Instrument Sans', sans-serif",
            fontSize: '16px'
          }} data-id="element-60" data-mp="cus0b2gjoydy">
                  {link.label}
                </a>)}
          </div>
        </div>

        {/* Green Separator Line - Full Width */}
        <div className="w-full h-px mb-8 md:mb-12" style={{
        backgroundColor: '#074030',
        opacity: 0.5
      }} data-id="element-61" data-mp="13s98fyrcotk8" />

        <div className="max-w-7xl mx-auto px-4" data-id="element-62" data-mp="1clumtgzls8t4">
          {/* Large Logo */}
          <div className="w-full" data-id="element-63" data-mp="1cnyodsa14vq8">
            <img src="https://cdn.magicpatterns.com/uploads/oaMs6zp7hbUHVrxri2Qay2/fifth-door-dooter-logo.png" alt="Fifth Door" className="w-full h-auto object-contain" style={{
            display: 'block',
            maxWidth: '100%'
          }} data-id="element-64" data-mp="1hjw6a30xya54" />
          </div>
        </div>
      </div>
    </footer>;
}